import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { ICreditMap } from '@leedpulse-monorepo/interfaces';
import { SubscriptionStatus } from '@leedpulse-monorepo/enums';

interface TerminateSubscriptionPayload {
  subscription_id: string;
  termination_date?: number; // Ignored for Leedflow (end of the Stripe billing period)
}

interface TerminateSubscriptionResponse {
  subscription_id: string;
  status: SubscriptionStatus;
  plan_end: number;
  notes: string;
  credits: ICreditMap;
  sender: string[];
  payment_wall: boolean;
}

async function terminateSubscription(
  payload: TerminateSubscriptionPayload,
  auth: Authentication
): Promise<TerminateSubscriptionResponse> {
  try {
    const response = await HttpClient.post('/subscription/terminate', payload, auth.token);
    return response.data;
  } catch (e: any) {
    console.error('terminateSubscription error:', e);
    throw new TerminateSubscriptionFailure(e.message);
  }
}

export class TerminateSubscriptionFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default terminateSubscription;
